/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'

import React from 'react'
import './animation.css'

const ChatMessage = ({ conversation, onDelete, canDelete }: any) => {
	const messageRef = React.useRef<HTMLDivElement>(null)
	React.useEffect(() => {
		if (messageRef.current) {
			messageRef.current.classList.add('chat-message-appear')
		}
	}, [])

	const userMsg = conversation.userMessage
	const assistantMsg = conversation.assistantMessage

	return (
		<div ref={messageRef} className="space-y-2">
			{userMsg && (
				<div className="mb-1 flex items-end justify-end">
					<div className="bg-muted text-foreground max-w-xs rounded-2xl p-3 md:max-w-md">
						<p className="text-sm">{userMsg}</p>
					</div>
					<div className="ml-2">
						<div className="h-[3px] w-full rounded-full bg-white" />
					</div>
				</div>
			)}
			{assistantMsg && (
				<div className="flex flex-col gap-2">
					{(() => {
						const parts = assistantMsg
							.split(/\r?\n+/)
							.flatMap((line: string) => line.trim().match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [])
							.map((s: string) => s.trim())
							.filter(Boolean)
						return (parts.length ? parts : [assistantMsg]).map((text: string, idx: number) => (
							<div
								key={`assistant-${conversation.id}-${idx}`}
								className="flex items-end justify-start"
							>
								<div className="mr-2">
									<div className="bg-primary h-[3px] w-full rounded-full" />
								</div>
								<div className="bg-brand-accent/20 text-foreground max-w-xs rounded-2xl p-3 md:max-w-md">
									<p className="text-sm">{text}</p>
									{canDelete && onDelete && idx === parts.length - 1 && (
										<button
											className="ml-2 text-xs text-red-400 hover:underline"
											onClick={() => onDelete(conversation.id)}
											title="Eliminar mensaje"
										>
											Eliminar
										</button>
									)}
								</div>
							</div>
						))
					})()}
				</div>
			)}
		</div>
	)
}

export default ChatMessage
